$(document).ready(function() {
	$(document).on('click', '.js-modal-excursion-item', function() {
		$('.js-modal-excursion-item').removeClass('active');
		$(this).addClass('active');
		$(this).parents('.js-modal').find('.js-modal-excursion-button').prop('disabled', false);
	});
	$(document).on('click', '.js-modal-excursion-theme', function() {
		$(this).toggleClass('active');
		if ($('.js-modal-excursion-theme.active').length > 0) {
			$(this).parents('.js-modal').find('.js-modal-excursion-button').addClass('active');
		} else {
			$(this).parents('.js-modal').find('.js-modal-excursion-button').removeClass('active');
		}
	});
});



// WEBPACK FOOTER //
// ./src/js/pages/modal-excursion/modal-excursion.js